<template>
    <transition name="modal">
        <div id="mvp-modal" class="modal-mask direction-rtl">
            <div class="mask-close" @click="$emit('close')"></div>
            <div class="modal-wrapper justify-content-between">
                <div class="modal-container col-12 col-md-6 col-lg-6 mt-xl-4 mt-sm-0 ">
                    <div class="modal-header py-0 direction-ltr">
                        <button v-if="!mobile" type="button" class="close pull-left ml-0 pl-0 pt-0 mt-0" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <button v-else type="button" class="close close-mobile pull-left ml-0 pl-0 pt-0 mt-0" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <h4 class="modal-title text-center mb-3">{{ $t('ספרו קצת על עצמכם ויצאנו לדרך') }}</h4>
                                <p class="text-center">{{ $t('במידה ותמצאו מתאימים, נחזור אליכם עבור המשך התהליך') }}</p>
                            </div>
                        </div>
                        <form class="popup-form mx-auto mt-2 mb-4">
                            <div class="form-group">
                                <input v-model="name" type="text" class="form-control dev-input"
                                       :placeholder="$t('שם מלא')"
                                       :class="{'text-right': language === 'he', 'text-left': language === 'en'}"
                                >
                            </div>
                            <div class="form-group">
                                <input v-model="phone" type="number" class="form-control dev-input"
                                       :placeholder="$t('מספר טלפון')" @input="leadCatching" :class="{'text-right': language === 'he', 'text-left': language === 'en'}">
                            </div>
<!--                            <div class="form-group">-->
<!--                                <input v-model="email" type="email" class="form-control dev-input"-->
<!--                                       placeholder="כתובת דואר אלקטרוני">-->
<!--                            </div>-->
                            <div class="form-group">
                                <textarea v-model="content" :placeholder="$t('משפט וחצי שידליקו אותנו עליכם')" class="form-control dev-input" :class="{'text-right': language === 'he', 'text-left': language === 'en'}"></textarea>
                            </div>
                            <div class="form-group">
                                <button
                                        class="btn btn-block dev-submit"
                                        :disabled="!isFormValid"
                                        @click.prevent="submitForm"
                                >
                                    <span v-if="!loading">{{ $t('#התחלנו') }}</span>
                                    <svg v-if="loading" fill="#fff" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                                    <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(300 25 25)">
                                                        <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                                                    </path>
                                                </svg>
                                </button>
                            </div>
                        </form>
                        <div class="footer-area text-center m-auto">
                            <div class="row">
                                <div class="col-12 col-lg-6">
                                    <img class="img-fluid footer-image m-auto d-block" src="/img/icon.svg" />
                                </div>
                                <div class="col-12 col-lg-6 pt-2" :class="{'text-right': language === 'he', 'text-left': language === 'en'}">
                                    <!--                                <p>זה 100% יקרה, ואם נגיד שזה 99% יקרה - זה 100% לא יקרה</p>-->
                                    <h5 class="m-0 p-0">{{ $t('וזכרו') }}</h5>
                                    <p class="motivation">{{ $t('"זה 100% יקרה. ואם תגידו שזה רק 99% יקרה, זה 100% לא יקרה." א.סמו') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import axios from 'axios';

    export default {
        name: 'mvp-form',
        data () {
            return {
                loading: false,
                name: null,
                content: null,
                phone: null,
                email: null,
                error: null,
            }
        },
        computed: {
            ...mapState('layout', {
                language: state => state.language,
            }),
            ...mapGetters({
                mobile: 'layout/mobile',
            }),
            isFormValid () {
                return this.name && (this.phone && (this.phone.toString().length > 6) && (this.phone.toString().length < 13));
            },
        },
        methods: {
            leadCatching() {
                return this.phone && this.phone.toString().length === 10
                    ? window.fbq('track', 'Lead', {value: this.phone}) : null;
            },
            submitForm () {
                this.isFormValid ? this.sendData() : null;
            },
            sendData () {
                this.loading = true;
                window.fbq('track', 'CompleteRegistration', {value: this.phone});
                axios.post('/mvp', {
                    name: this.name,
                    phone: this.phone,
                    content: this.content,
                }).then(response => {
                    this.loading = false;
                    !response.data.error ? this.$swal({
                        title: this.$i18n.t('בהצלחה'),
                        text: this.$i18n.t('פנייתך נשלחה ותיענה בהקדם'),
                        type: 'success',
                        confirmButtonText: this.$i18n.t('הבנתי'),
                    }) : this.$swal({
                        title: this.$i18n.t('אופססס...'),
                        text: this.$i18n.t('תקלת רשת, נסה מאוחר יותר'),
                        type: 'error',
                        confirmButtonText: this.$i18n.t('הבנתי'),
                    });
                    this.$emit('close');
                }).
                catch(error => {
                    this.loading = false;
                    this.error = error;
                    this.$swal({
                        title: this.$i18n.t('אופססס...'),
                        text: this.$i18n.t('תקלת רשת, נסה מאוחר יותר'),
                        type: 'error',
                        confirmButtonText: this.$i18n.t('הבנתי'),
                    });
                    this.$emit('close');
                });
            },
        },
    }
</script>

<style lang="css" scoped>
    .close:focus {
        border:none;
        outline: none;
    }
    .close {
        cursor: pointer;
    }
    .modal-mask {
        position: fixed;
        z-index: 10000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, .6);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: block;
        overflow-y: auto;
        vertical-align: middle;
        width: 100%;
        height: 100%;
    }
    .mask-close{
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
    }
    #mvp-modal .modal-header {
        border: none;
    }
    .modal-container {
        margin: auto;
        z-index: 100;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        -webkit-overflow-scrolling: touch;
        max-width: 650px;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #000;
        font-weight: 300;
    }

    .modal-body {
        margin: 20px 0;
        -webkit-overflow-scrolling: touch;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }
    .dev-input {
        font-size: 16px;
        padding: 15px 15px;
        border-radius: 25px 25px 25px 25px;
    }
    .dev-submit {
        background: linear-gradient(144deg, #7719b4 10%, #bf35d0 65%);
        height: 48px;
        min-width: 185px;
        cursor: pointer;
        color: #ffffff;
        font-weight: 500;
        border-radius: 22px 25px 22px 22px;
    }
    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    .footer-image {
        height: auto;
        width: 100px;
    }
    @media(max-width:767px) {
        .modal-mask {
            margin: 0!important;
            max-width: none!important;
            position: fixed!important;
            left: 0!important;
            right: 0!important;
            top: 0!important;
            bottom: 0!important;
        }
        .modal-container {
            min-height: 100%;
            min-width: 100%;
            height: 100%!important;
            position: fixed!important;
            left: 0!important;
            right: 0!important;
            top: 0!important;
            bottom: 0!important;
            margin: 0!important;
            overflow-y: auto;
        }
        .no-border-bottom {
            border-bottom: none;
        }
    }
    .popup-form, .footer-area {
        max-width: 450px;
    }
    .footer-area h5 {
        color: #495057;
        font-size: 16px;
    }
    p.motivation {
        color: #495057;
        font-size: 14px;
    }
    .direction-ltr {
        direction: ltr !important;
    }
</style>
